import { Box, Collapse, Container, IconButton, Link, Stack, useMediaQuery } from "@mui/material";
import SkeletonImage from "../../../components/ui/SkeletonImage";
import SearchInput from "../../../components/ui/SearchInput";
import MemberMenu from "../../Protected/MemberMenu";
import { Link as NavLink } from "react-router-dom";
import Images from "../../../assets/js/Images";
import Icons from "../../../assets/js/Icons";
import { Fragment, useEffect, useState } from "react";
import TopHeader from "./TopHeader";
import NavMenu from "./NavMenu";
import { menus } from "./data";
import { checkToken, checkUserType } from "../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { showDialogWithData } from "../../../redux/guest-slices/other.slice";
import { SUBSCRIPTION_CHECKOUT } from "utils/keywords";

function Header({ sidebarActive }) {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const isXs = useMediaQuery("(max-width:300px)");
  const userType = checkUserType();
  const currentRole = userType === false ? "guest" : userType;

  // Dynamically compute menus with Dashboard when authenticated
  const authChecked = checkToken();
  const allMenus = authChecked?.valid
    ? [
      menus[0], // home 
      { name: "dashboard", path: `/${userType}/profile` },
      ...menus.slice(1), // rest of menus
    ]
    : menus;

  const { subscription } = useSelector(
    (state) => state.subscriptionSlice
  );

  useEffect(() => {
    if (!authChecked?.valid) return;

    if (authChecked?.userRole !== "member") {
      localStorage.removeItem("selectedSubscriptionPlan");
      return;
    }

    if (!subscription) return;

    const hasActiveSubscription =
      subscription?.hasSubscription ||
      (subscription?.status === "active" && subscription?.plan?.name !== "basic") ||
      (subscription?.plan?.name && subscription?.plan?.name !== "basic");

    if (hasActiveSubscription) {
      localStorage.removeItem("selectedSubscriptionPlan");
      return;
    }

    const pendingPlan = JSON.parse(
      localStorage.getItem("selectedSubscriptionPlan")
    );

    if (pendingPlan?.stripePriceId) {
      dispatch(
        showDialogWithData({
          type: SUBSCRIPTION_CHECKOUT,
          data: pendingPlan,
        })
      );
    }
  }, [authChecked, subscription]);
  return (
    <Fragment>
      <TopHeader isAuthenticated={authChecked?.valid} />

      <Box
        component="header"
        p={{ xs: 1, desktop: 0 }}
        boxShadow="0 0 10px 0px #00000029"
        sx={{
          width: "100%",
          maxWidth: "100vw",
          // overflowX: "hidden",
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            mb: { xs: 0.75, md: 0 },
            px: { xs: "15px", xxl: "30px" },
          }}
        >
          <Box
            sx={{
              gap: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Link
              to="/"
              component={NavLink}
              sx={{
                mr: "10px",
                display: "inline-block",
                height: { xs: "30px", sm: "40px" },
                minWidth: { xs: "100px", sm: "140px" },
              }}
            >
              <SkeletonImage
                sx={{
                  objectFit: "contain",
                  width: "100%",
                  height: "100%",
                  minWidth: { xs: "100px", sm: "140px" },
                }}
                src={Images?.mainLogo}
              />
            </Link>

            <Stack
              component="nav"
              direction="row"
              sx={{ display: { xs: "none", desktop: "flex", flexWrap: "wrap" } }}
            >
              {allMenus
                ?.filter((menu) => {
                  if (!menu.roles) return true;
                  return menu.roles.includes(currentRole);
                })
                .map((menu, i) => (
                  <NavMenu
                    key={i}
                    index={i}
                    menu={menu}
                    activeIndex={activeIndex}
                    setActiveIndex={setActiveIndex}
                  />
                ))}
            </Stack>


            <Box sx={{ display: { xs: "none", desktop: "block" } }}>
              <MemberMenu />
            </Box>
            <Box>
              <IconButton
                size={isXs ? "small" : "medium"}
                onClick={() => {
                  setIsActive(!isActive);
                }}
                sx={{ mr: "4px", display: { sm: "none" } }}
              >
                <Icons.Search />
              </IconButton>
              <IconButton
                onClick={sidebarActive}
                size={isXs ? "small" : "medium"}
                sx={{ display: { desktop: "none" } }}
              >
                <Icons.Menu />
              </IconButton>
            </Box>
          </Box>
          <Collapse in={isActive} timeout={300} unmountOnExit sx={{ mt: 1 }}>
            <SearchInput />
          </Collapse>
        </Container>
      </Box>
    </Fragment>
  );
}

export default Header;
